// 个人信息模块
export default {
    Personal: {
        SetPassword: '设置密码',
        PleaseEnterPassword: '请输入密码',
        PleaseEnterPasswordAgain: '请再次输入密码',
        ChangePassword: '修改密码',
        PleaseEnterOldPassword: '请 输 入 旧 密 码',
        PleaseEnterOldPassword2: '请输入旧密码',
        PleaseEterNewPassword: '请 输 入 新 密 码',
        PleaseEterNewPassword2: '请输入新密码',
        PleaseEnterNewPasswordAgain: '请再次输入新密码',
        ModifyAvatar: '修改头像',
        LocalUpload: '本地上传',
        LocalUploadTip: '仅支持JPG、GIF、PNG、JPEG、BMP格式，文件小于5M',
        EffectPreview: '效果预览',
        Pixels: '100*100像素',
        UserInformation: '用户信息',
        HeadPortrait: '头像:',
        ReplaceAvatar: '更换头像',
        UserName: '用户名:',
        EnterUserName: '请输入用户名',
        UserNameCanOnlyModifiedOnce: '用户名只可修改一次',
        ModifyUserName: '修改用户名',
        NewUsername: '新用户名',
        CellPhoneNumber: '手机号:',
        PleaseEnterPhoneNumber: '请输入手机号',
        PleaseBindPhoneNumber: '根据网信办规定，发布信息必须绑定手机号，请您及时绑定手机号。',
        UnbindPhoneNumber: '解绑手机号',
        BindPhoneNumber: '绑定手机号',
        PleaseEnterYourPhoneNumber: '请输入您的手机号',
        PleaseEnterVerificationCode: '请输入验证码',
        SendVerificationCode: '发送验证码',
        Resend: '重新发送',
        Password: '密码：',
        Mailbox: '邮箱：',
        SetUpEmail: '设置邮箱',
        BindEmail: '绑定邮箱',
        ModifyEmail: '修改邮箱',
        VerifyEmailAddress: '验证邮件地址',
        EmailAddress: '邮件地址',
        SendVerificationEmail: '发送验证邮箱',
        SendEmail: '发送邮箱',
        SentTo: '验证邮件已经发送到你的邮箱',
        PleaseCheckEmail: '中，请查收',
        NoEmailReceived: '没有收到邮件？请检查一下垃圾邮件或者点击',
        FullName: '姓名：',
        PleaseEnterYourName: '请输入姓名',
        Address: '地址：',
        PleaseSelectProvince: '请选择省',
        PleaseSelectCity: '请选择市',
        PleaseSelectCounty: '请选择县',
        ModifyAddress: '修改地址',
        PleaseEnterCorrectPhoneNumber: '请输入正确的手机号',
        PhoneNumberCannotEmpty: '手机号不能为空!',
        UserNameCannotEmpty: '用户名不能为空!',
        PleaseFillEmailAddress: '请填写邮件地址!',
        PleaseFillCorrectEmailAddress: '请填写正确的邮件地址!',
        FileCannotExceed5MB: '上传文件大小不能超过 5MB，请重新选择图片!',
        OldPasswordCannotEmpty: '旧密码不能为空',
        NewPasswordCannotEmpty: '新密码不能为空',
        SecondaryPasswordCannotEmpty: '二次密码不能为空',
        PasswordsEnteredDifferent: '您输入的两次密码不相同!',
        SuccessfullyModified: '修改成功',
        SuccessfullySet: '设置成功',
        PleaseSelectCityOrCounty: '请选择市或县区'
    },
  };